import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
//import IntNumberFormatInput from '../../int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
//import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 50,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    width_obsv: {
        width: 500,
    },
    width_descr: {
        width: 400,
    },
    width_cod_sm: {
        width: 50,
    },
    width_cod_md: {
        width: 100,
    },
    width_cod_lg: {
        width: 400,
    },

});

class EditCvSubFamilia extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: this.props.subFamilia.id ? this.props.subFamilia.id : uuidv4(),
            descr: this.props.subFamilia.descr ? this.props.subFamilia.descr : '',
            cod: this.props.subFamilia.cod ? this.props.subFamilia.cod : '',
            iFamilia: this.props.subFamilia.iFamilia ? this.props.subFamilia.iFamilia : this.props.familiaList[0].id,
            familiaDescr: this.props.subFamilia.familiaDescr ? this.props.subFamilia.familiaDescr : this.props.familiaList[0].descr, //
        }

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });

    };

    compareDescr = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    }

    fillSelectOptionList = () => {

        return this.props.familiaList.sort(this.compareDescr).map(gp => {
            return (
                <option key={gp.id} value={gp.id}>{gp.descr}</option>
            );
        });

    };

    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iFamilia: value,
            familiaDescr: this.props.familiaList.find(gp => gp.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div >
                    <FormControl className={`${classes.formControl} ${classes.width_cod_sm}`}>
                        <TextField
                            id={'cod'}
                            label={'Código'}
                            placeholder={'Código'}
                            className={classes.textField}
                            margin="normal"
                            value={this.state.cod}
                            onChange={(event) => this.handleValueChange(event, 'cod')}
                        />
                    </FormControl>
                </div>
                <div >
                    <FormControl className={`${classes.formControl} ${classes.width_descr}`}>
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            className={classes.textField}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={(event) => this.handleValueChange(event, 'descr')}
                        />
                    </FormControl>
                </div>

                <div className={`${classes.containerPair} ${classes.margin}`}>
                    <FormControl className={`${classes.formControl} ${classes.width_cod_lg}`}>
                        <InputLabel htmlFor="familia-placeholder">
                            Familia
                    </InputLabel>
                        <Select
                            native
                            value={this.state.iFamilia}
                            onChange={(event) => this.handleChangeSelect(event)}
                        >
                            {this.fillSelectOptionList()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const subFamilia = {
                            id: this.state.id,
                            descr: this.state.descr,
                            cod: this.state.cod,
                            familiaDescr: this.state.familiaDescr,
                            iFamilia: this.state.iFamilia
                        }


                        if (this.props.checkSubFamilia(subFamilia)) {

                            this.props.okHandler(subFamilia);
                            this.props.hideDialog();
                        }
                    }
                    }>Guardar</Button>
                </div>
            </div>
        )
    }

};

EditCvSubFamilia.propTypes = {
    subFamilia: PropTypes.object.isRequired,
    checkSubFamilia: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvSubFamilia);